import React, { createContext, useMemo } from 'react';
import { viewerTypes } from '../constants/constants';

const PreviewContext = createContext();

const usePreviewContext = () => {
  const context = React.useContext(PreviewContext);

  if (!context) {
    return { startFrom: null, duppedBreakIdx: null, fromViewer: null, forceHover: false }
  }

  return context;
};

const PreviewProvider = ({ children, startFrom = null, duppedBreakIdx = null, forceHover }) => {
  const parentContext = React.useContext(PreviewContext);

  const value = useMemo(() => {
    const inheritedForceHover = parentContext?.forceHover ?? false;
    return {
      startFrom,
      duppedBreakIdx,
      fromViewer: viewerTypes.PREVIEW,
      forceHover: forceHover ?? inheritedForceHover,
    }
  }, [startFrom, duppedBreakIdx, forceHover, parentContext?.forceHover])

  return (
    <PreviewContext.Provider value={value}>
      {children}
    </PreviewContext.Provider>
  );
};

export { PreviewProvider, usePreviewContext };
